import React, {  useMemo, useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCHidden, RCCHookToast, RCCIcon, RCCServicesApi } from "react-common-components";
import Accordion from "src/components/Accordion";
import Loader from "src/components/Loader";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { checkSituationOccurrence, IGrouperOfOccurrence, IOccurrence } from "../interface";
import { FilterButton, FilterButtonSelected } from "../styles";
import ListOfOccurences from "./listOfOccurences";

const GrouperOfOccurences: React.FC<IGrouperOfOccurrence> = ({
	grouper,
	filters,
	groupersSelect,
	loadGroupers,
	layoutList
}) => {
	const {translate} = useTranslation();
	const {addToast} = RCCHookToast();
	const [grouperData, setGrouperData] = useState(grouper);
	const [list, setList] = useState<IOccurrence[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	const [filterListSituation, setFilterListSituation] = useState<checkSituationOccurrence | undefined>(undefined);

	const handleClickGroupers = async (_e: any, expanded: boolean) => {
		if(!expanded)
			return;
		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "Occurrences/List",
				urlParameters: {
					...groupersSelect,
					id: grouperData.id || "",
					id2: grouperData.id2 || "",
					id3: grouperData.id3 || "",
					...filters
				}
			});

			const listOccurrence = data as IOccurrence[];
			setList(listOccurrence);
			setLoading(false);	
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar as ocorrências"), addToast);
			setLoading(false);	
		}
	};

	const onCallbackDelete = (ocb001Id: number) => {
		const objToDelete = list.filter((x) => x.ocb001Id === ocb001Id)[0];

		setList((prevState) => prevState.filter((x) => x.ocb001Id !== ocb001Id));
		const updateGrouper = grouper;

		if(objToDelete.late && (objToDelete.ocb001Status !== checkSituationOccurrence.DISAPPROVED && objToDelete.ocb001Status !== checkSituationOccurrence.FINISHED && objToDelete.ocb001Status !== checkSituationOccurrence.CANCELED)){
			updateGrouper.late -= 1;
			updateGrouper.count -= 1;
		}else{
			switch(objToDelete.ocb001Status){
			case checkSituationOccurrence.CANCELED:
				updateGrouper.canceled -= 1;
				updateGrouper.count -= 1;
				break;
			case checkSituationOccurrence.DISAPPROVED:
				updateGrouper.disaproved -= 1;
				updateGrouper.count -= 1;
				break;
			case checkSituationOccurrence.FINISHED:
				updateGrouper.finished -= 1;
				updateGrouper.count -= 1;
				break;
			case checkSituationOccurrence.NOT_STARTED:
				updateGrouper.notStarted -= 1;
				updateGrouper.count -= 1;
				break;
			case checkSituationOccurrence.OPENED:
				updateGrouper.opened -= 1;
				updateGrouper.count -= 1;
				break;
			default: 
				break;
			}
		}

		setGrouperData(updateGrouper);
		
	};

	const onCallbackUpdate = async (id: number) => {
		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "Occurrences/InfosOfOccurrenceForList",
				urlParameters: {
					id
				}
			});

			const occurrence = data as IOccurrence;

			setList((prevState) => prevState.map((glist) => {
				if(glist.ocb001Id === id)
					return occurrence;
				return glist;
			}));

		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar ocorrência, favor atualizar a pagina"), addToast);
		}
	};

	const filterSituationRisksOnClickCountBar = (situation: checkSituationOccurrence) => {
		let situationToUpdate: checkSituationOccurrence | undefined = situation;

		if(filterListSituation && filterListSituation === situation)
			situationToUpdate = undefined;

		setFilterListSituation(situationToUpdate);
	};

	const ListOfOccurencesMemo = useMemo(() => (
		<>
			<ListOfOccurences 
				data={list}
				layoutList={layoutList}
				onCallbackDelete={onCallbackDelete}
				onCallbackUpdate={onCallbackUpdate}
				loadGroupers={loadGroupers}
				filterList={filterListSituation}
			/>
		</>
	), [filterListSituation, list, layoutList, grouper]);

	return (
		<Accordion 
			header={
				<>
					<RCCGrid 
						container
						item 
						alignItems="center"
						justifyContent="space-between"
					>
						<span style={{ display: "flex", alignItems: "center"}}>
						 {grouperData.image !== null && (
								<Photo 
									hover
									name={grouperData.imageName || ""}
									link={grouperData.image !== "" ? `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${grouperData.image}` : ""}
								/>
							)}
							{grouperData.title}
							{grouperData.title2 !== null && (
								<>
									<RCCIcon name="arrowRight" size={20} />
									{grouperData.title2}
								</>
							)}
							{grouperData.title3 !== null && (
								<>
									<RCCIcon name="arrowRight" size={20} />
									{grouperData.title3}
								</>
							)}
						</span>
						<RCCGrid container justifyContent="flex-end">
							{grouperData.notStarted > 0  && (
								<RCCButton 
									color="blue" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.NOT_STARTED ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.NOT_STARTED); }}
								>{grouperData.notStarted} <RCCHidden only="xs">{grouperData.notStarted > 1 ? translate("não iniciadas") : translate("não iniciada")}</RCCHidden> 
								</RCCButton>
							)}
							{grouperData.opened > 0 && (
								<RCCButton 
									color="purple" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.OPENED ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.OPENED); }}
								>{grouperData.opened} <RCCHidden only="xs">{translate("em andamento")}</RCCHidden> 
								</RCCButton>
							)}
							{grouperData.late > 0 && (
								<RCCButton 
									color="red" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.LATE ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.LATE); }}
								>
									{grouperData.late} <RCCHidden only="xs">{grouperData.late > 1 ? translate("atrasadas") : translate("atrasada")}</RCCHidden> 
								</RCCButton>
							)}
							{grouperData.finished > 0 && (
								<RCCButton 
									color="green" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.FINISHED ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.FINISHED); }}
								>
									{grouperData.finished} <RCCHidden only="xs">{grouperData.finished > 1 ? translate("finalizadas") : translate("finalizada")}</RCCHidden> 
								</RCCButton>
							)}
							{grouperData.canceled > 0  && (
								<RCCButton 
									color="grey" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.CANCELED ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.CANCELED); }}
								>{grouperData.canceled} <RCCHidden only="xs">{grouperData.canceled > 1 ? translate("canceladas") : translate("cancelada")}</RCCHidden> 
								</RCCButton>
							)}
							{grouperData.disaproved > 0  && (
								<RCCButton 
									color="black" 
									styleInline={filterListSituation && filterListSituation !== checkSituationOccurrence.DISAPPROVED ? FilterButtonSelected : FilterButton}
									onClick={(e) => { e.stopPropagation(); filterSituationRisksOnClickCountBar(checkSituationOccurrence.DISAPPROVED); }}
								>{grouperData.disaproved} <RCCHidden only="xs">{grouperData.disaproved > 1 ? translate("reprovadas") : translate("reprovada")}</RCCHidden>
								</RCCButton>
							)}
							<Title color="purple" size="sm" styleInline="margin 0 4px;">{translate("Total")}: {grouperData.count}</Title>
						</RCCGrid>
					</RCCGrid>
				</>
			}
			onChange={(e : any, expanded: any) => handleClickGroupers(e, expanded)}
		>
			{loading ? (
				<Loader />
			): (
				<>
					{list ? (
						<>
							{ListOfOccurencesMemo}
						</>     
					): (
						<RCCAlert 
							title={translate("Atenção")}
							description={translate("Erro ao tentar encontrar resultados para esta pesquisa")}
						/>
					)}
				</>
			)}
		</Accordion>
	);
};

export default GrouperOfOccurences;
